import { getGlobalParams, getContractorInfo } from './bridge.js'
import store from '@/store'
import bridgeInit from '@didi/sailing-bridge'
import { isDebug } from '@/utils/common/env.js'
import { passportLogin } from '@/utils/passport/login.js'

/**
 * 管理端app初始化：通过 getGlobalParams 和 getContractorInfo 获取公参与主体信息
 */
export function setMerchantManagerGlobalConfig(resolve) {
  try {
    Promise.all([getGlobalParams(), getContractorInfo()])
      .then(([globalParams, contractorInfo]) => {
        // 初始化bridge监控
        bridgeInit({
          module: 'bH5',
          Omega: window.Omega,
          params: globalParams,
          options: { showLog: true },
        })
        store.commit('UPDATE_CURRENT_CONTRACTOR', contractorInfo)
        // 管理端使用主体信息中的 countryCode
        store.commit('UPDATE_CURRENT_COUNTRY', contractorInfo && contractorInfo.countryCode)
        store.commit('UPDATE_GLOBAL_PARAMS', {
          ...globalParams,
          businessType: (contractorInfo && contractorInfo.businessType) || '',
        })
        resolve()
      })
      .catch(e => {
        console.log('MerchantManager init error', e)
        if (isDebug) {
          passportLogin(resolve)
        }
      })
  } catch (error) {
    console.log('MerchantManager init error', error)
    if (isDebug) {
      passportLogin(resolve)
    }
  }
}

/**
 * 管理端app主体切换时更新公参与主体信息
 * 在端上通过 triggerContractorInfoUpdated 回调通知 H5 时调用
 * 同时重新获取公参（globalParams）和主体信息（contractorInfo）
 */
export function refreshMerchantManagerContractorInfo() {
  return Promise.all([getGlobalParams(), getContractorInfo()])
    .then(([globalParams, contractorInfo]) => {
      // 更新主体信息
      store.commit('UPDATE_CURRENT_CONTRACTOR', contractorInfo)
      store.commit('UPDATE_CURRENT_COUNTRY', contractorInfo && contractorInfo.countryCode)
      // 更新公参
      if (globalParams) {
        store.commit('UPDATE_GLOBAL_PARAMS', {
          ...globalParams,
          businessType: (contractorInfo && contractorInfo.businessType) || '',
        })
      }
      return contractorInfo
    })
    .catch(e => {
      console.log('refreshMerchantManagerContractorInfo error', e)
      throw e
    })
}
